export enum EnumSettingState {
  ON_REQUEST_SUCCESS = "ON_REQUEST_SUCCESS",
  ON_HISTORY_PAGE = "ON_HISTORY_PAGE",
  IN_FIRST_PAGE = "IN_FIRST_PAGE",
}
